
<div class="ui bottom tab segment" data-tab="additional_condition">
  <form class="ui form" :class="{'loading': form.waiting}">
    <div class="field">
      <button type="button" class="ui positive button" @click="save()">保存する</button>
    </div>
    <div class="ui stackable three column grid">
      <div v-for="each in additionalConditions" :key="each.value" class="column">
        <div class="field">
          <div class="ui checkbox">
            <input v-model="each.checked" type="checkbox" value="true">
            <label>{{ each.label }}</label>
          </div>
         (
          <div class="ui checkbox" style="margin-right: 0;">
            <input v-model="each.is_conditional" type="checkbox" value="true" :disabled="!each.checked">
            <label>条件付き</label>
          </div>
         )
        </div>
        <div class="field">
          <textarea :disabled="!each.checked" rows="2" v-model="each.note" :placeholder="each.placeholder"></textarea>
        </div>
      </div>
    </div>
  </form>
</div>
